import { getAddress, isAddress } from "viem";

export const HEX_32_BYTE_ID_REGEX = /^0x[0-9a-f]{64}$/i;

/** V4 pools use a bytes32 pool id; V3 uses a 20-byte contract address. */
export function isV4PoolId(poolId: string): boolean {
	const normalized = poolId.trim().toLowerCase();
	const withPrefix = normalized.startsWith("0x") ? normalized : `0x${normalized}`;
	return HEX_32_BYTE_ID_REGEX.test(withPrefix);
}

/**
 * Normalize a pool identifier from user input; returns null if invalid.
 * V3 pools use 20-byte EVM addresses. V4 pools use 32-byte pool ids.
 */
export function normalizePoolAddressOrNull(raw: string): string | null {
	const t = raw.trim();
	if (!t) return null;
	const withPrefix = /^0x/i.test(t) ? t : `0x${t}`;

	if (HEX_32_BYTE_ID_REGEX.test(withPrefix)) {
		return withPrefix.toLowerCase();
	}

	if (!isAddress(withPrefix)) return null;
	try {
		return getAddress(withPrefix);
	} catch {
		return null;
	}
}
